import { render } from "./ShipmentList_completed_date.vue?vue&type=template&id=4f8acc4b&scoped=true"
import script from "./ShipmentList_completed_date.vue?vue&type=script&lang=js"
export * from "./ShipmentList_completed_date.vue?vue&type=script&lang=js"

import "./ShipmentList_completed_date.vue?vue&type=style&index=0&id=4f8acc4b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8acc4b"]])

export default __exports__